import ColorPickerField from '@anm/components/ColorPicker/ColorPickerField';
import { SelectOption } from '@anm/components/select/Select';
import { DEFAULT_WAVE_COLOR } from '@anm/constants/colors';
import { useCallback, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CurrentValue } from '..';
import {
  hostedVideoActions,
  hostedVideoSelectors
} from '../../../../store/modules/hostedVideo';
import { Controls } from '../ControlsPanel';
import CustomizationFormCheckbox from '../CustomizationFormCheckbox';
import CustomizationFormSelect from '../CustomizationFormSelect';

export type ControlProps = Controls & {
  onChange: (value: CurrentValue) => void;
  values?: SelectOption[];
  renderTooltip?: () => JSX.Element;
};

const Control: FC<ControlProps> = props => {
  const isSelect = props.type === 'select' && !!props.values;
  const isColorPicker = props.type === 'color';
  const playerColor = useSelector(hostedVideoSelectors.selectPlayerColor);
  const dispatch = useDispatch();
  const handleColorChange = useCallback((color: string) => {
    dispatch(hostedVideoActions.updatePlayerColor(color));
  }, []);

  const isCheckboxDefaultChecked =
    typeof props.controlValue === 'boolean' && props.controlValue;

  switch (true) {
    case isSelect:
      return <CustomizationFormSelect {...props} values={props.values!} />;

    case isColorPicker:
      return (
        <ColorPickerField
          initialColor={playerColor || DEFAULT_WAVE_COLOR}
          onColorChange={handleColorChange}
        />
      );

    default:
      return (
        <CustomizationFormCheckbox
          {...props}
          controlValue={!!props.controlValue}
          isDefaultChecked={isCheckboxDefaultChecked}
        />
      );
  }
};

export default Control;
